/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProgramCopyRequest
 */
export interface ProgramCopyRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramCopyRequest
     */
    programIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProgramCopyRequest
     */
    targetOrganizationId: string;
}

/**
 * Check if a given object implements the ProgramCopyRequest interface.
 */
export function instanceOfProgramCopyRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "programIds" in value;
    isInstance = isInstance && "targetOrganizationId" in value;

    return isInstance;
}

export function ProgramCopyRequestFromJSON(json: any): ProgramCopyRequest {
    return ProgramCopyRequestFromJSONTyped(json, false);
}

export function ProgramCopyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramCopyRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programIds': json['programIds'],
        'targetOrganizationId': json['targetOrganizationId'],
    };
}

export function ProgramCopyRequestToJSON(value?: ProgramCopyRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'programIds': value.programIds,
        'targetOrganizationId': value.targetOrganizationId,
    };
}

